import React from "react";
import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row, Col } from "react-bootstrap";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { useNavigate } from "react-router-dom";
import TaskStory from "../pages/TaskStory";
import TaskContent from "../pages/TaskContent";
import FilesData from "./FilesData";
import { TaskContext } from "../components/TaskContext";
import TaskSettlements from "./TaskSettlements";
import TaskChat from "./TaskChat";
import Button from "@mui/material/Button";
import TaskMap from "../pages/TaskMap";
import { apiRequest } from "../components/Config";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import TasksData from "../pages/TasksData";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function RedirectToTasks({ navigate }) {
  useEffect(() => {
    navigate("/tasks");
  }, [navigate]);

  return null;
}

export default function Tasks() {
  const { userData } = useContext(UserDataContext);
  const { taskId } = useContext(TaskContext);
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [task, setTask] = useState(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    //localStorage.setItem("selectedTabTasksEdit", newValue);
  };

  const handleNavigateTasks = () => {
    navigate("/tasks");
  };

  /*
  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTabTasksEdit");
    if (savedTab) {
      const parsedTab = parseInt(savedTab, 10);
      if (userData && (userData.permId === "1" || userData.permId === "3")) {
        if (parsedTab >= 0 && parsedTab <= 4) {
          setValue(parsedTab);
        }
      } else {
        if (parsedTab === 0) {
          setValue(parsedTab);
        }
      }
    }
  }, [userData]);
*/
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("task", "POST", {
          id: taskId,
        });
        if (Array.isArray(response)) {
          //console.log("task info: ", response);
          setTask(response);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
        }
        if (response.length === 0)
          console.log("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, [userData, taskId]);
  return (
    <div>
      <VN userData={userData} />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <ThemeProvider theme={theme}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="underMenu"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab label="Treść zlecenia" />
            <Tab label="Historia" />
            <Tab label="Pliki" />
            <Tab label="Korespondencja" />
            <Tab label="Rozliczenia" />
            <Tab label="Lokalizacja" />
            <Tab label="Lista zleceń" />
          </Tabs>
        </ThemeProvider>
      </Box>

      <hr />
      {task && task[0] && (
        <ThemeProvider theme={theme}>
          <Row>
            <Col md="2">
              <Row>
                <Col>
                  <p className="p1">Zlecenie ID [{taskId}]</p>
                </Col>
              </Row>
            </Col>
            <Col md="1">
              <p className={task[0].class}></p>
            </Col>
            <Col md="3">
              <p className="p1">Status: {task[0].status}</p>
            </Col>
            <Col md="4">
              <p className="p1">Wykonawca: {task[0].performerName}</p>
            </Col>
          </Row>
        </ThemeProvider>
      )}
      {/*
      <CustomTabPanel value={value} index={0}>
        <Row>Lista zleceń</Row>
      </CustomTabPanel>
      */}
      <CustomTabPanel value={value} index={0}>
        <Row>
          <TaskContent />
        </Row>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Row>
          <TaskStory />
        </Row>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <FilesData />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <TaskChat />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <TaskSettlements />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <TaskMap />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <RedirectToTasks navigate={navigate} />
      </CustomTabPanel>
    </div>
  );
}
